










import Vue from 'vue';
import { mapState as mapRootState } from 'vuex';
import DocumentView from './DocumentView.vue';
import DownloadIcon from '@/assets/img/download.svg';
export default Vue.extend({
    components: { DocumentView, DownloadIcon },
    props: {
        document: {
            type: Object,
            required: true,
        },
        moduleId: {
            type: String,
            required: true,
        },
        itemId: {
            type: ([Number, String] as unknown) as () => number | string,
            required: true,
        },
    },
    computed: {
        ...mapRootState(['instanceId']),
        href() {
            return `${process.env.VUE_APP_BASE_API_URL}${this.instanceId}/portal_documents/${this.moduleId}/${this.itemId}/${this.document.id}`;
        },
    },
});
